"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreDataSecurityWatchers = exports.coreDataSecurityReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const access_log_1 = require("./access-log/index.js");
const access_statistics_1 = require("./access-statistics/index.js");
const action_plan_1 = require("./action-plan/index.js");
const action_templates_1 = require("./action-templates/index.js");
const alerts_1 = require("./alerts/index.js");
const api_request_usage_1 = require("./api-request-usage/index.js");
const api_volume_1 = require("./api-volume/index.js");
const application_overview_1 = require("./application-overview/index.js");
const applications_1 = require("./applications/index.js");
const app_status_1 = require("./app-status/index.js");
const app_users_1 = require("./app-users/index.js");
const data_access_1 = require("./data-access/index.js");
const detected_applications_1 = require("./detected-applications/index.js");
const incident_log_1 = require("./incident-log/index.js");
const monitored_objects_1 = require("./monitored-objects/index.js");
const monitors_1 = require("./monitors/index.js");
const setup_audit_trail_1 = require("./setup-audit-trail/index.js");
const status_1 = require("./status/index.js");
const monitors_dashboard_1 = require("./monitors-dashboard/index.js");
const usage_1 = require("./usage/index.js");
exports.coreDataSecurityReducers = (0, redux_1.combineReducers)({
    accessLog: access_log_1.coreDataSecurityAccessLogReducers,
    accessStatistics: access_statistics_1.coreDataSecurityAccessStatisticsReducers,
    actionPlan: action_plan_1.coreDataSecurityActionPlanReducers,
    actionTemplates: action_templates_1.coreDataSecurityActionTemplatesReducers,
    alerts: alerts_1.coreDataSecurityAlertsReducers,
    apiRequestUsage: api_request_usage_1.coreDataSecurityApiRequestUsageReducers,
    apiVolume: api_volume_1.coreDataSecurityApiVolumeReducers,
    appStaus: app_status_1.coreDataSecurityAppStatusReducers,
    appUsers: app_users_1.coreDataSecurityAppUsersReducers,
    applicationOverview: application_overview_1.coreDataSecurityApplicationOverviewReducers,
    applications: applications_1.coreDataSecurityApplicationsReducers,
    dataAccess: data_access_1.coreDataSecurityDataAccessReducers,
    detectedApplications: detected_applications_1.coreDataSecurityDetectedApplicationsReducers,
    incidentLog: incident_log_1.coreDataSecurityIncidentLogReducers,
    monitoredObjects: monitored_objects_1.coreDataSecurityMonitoredObjectsReducers,
    monitors: monitors_1.coreDataSecurityMonitorsReducers,
    monitorsDashboard: monitors_dashboard_1.coreDataSecurityUptimeMonitorsDashboardReducers,
    setupAuditTrail: setup_audit_trail_1.coreDataSecuritySetupAuditTrailReducers,
    status: status_1.coreDataSecurityStatusReducers,
    usage: usage_1.coreDataSecurityUsageReducers
});
exports.coreDataSecurityWatchers = (0, xuder_1.combineAllWatchers)([
    access_log_1.coreDataSecurityAccessLogWatchers,
    access_statistics_1.coreDataSecurityAccessStatisticsWatchers,
    action_plan_1.coreDataSecurityActionPlanWatchers,
    action_templates_1.coreDataSecurityActionTemplatesWatchers,
    alerts_1.coreDataSecurityAlertsWatchers,
    api_request_usage_1.coreDataSecurityApiRequestUsageWatchers,
    api_volume_1.coreDataSecurityApiVolumeWatchers,
    app_status_1.coreDataSecurityAppStatusWatchers,
    app_users_1.coreDataSecurityAppUsersWatchers,
    application_overview_1.coreDataSecurityApplicationOverviewWatchers,
    applications_1.coreDataSecurityApplicationsWatchers,
    monitors_1.coreDataSecurityMonitorsWatchers,
    data_access_1.coreDataSecurityDataAccessWatchers,
    detected_applications_1.coreDataSecurityDetectedApplicationsWatchers,
    incident_log_1.coreDataSecurityIncidentLogWatchers,
    monitored_objects_1.coreDataSecurityMonitoredObjectsWatchers,
    setup_audit_trail_1.coreDataSecuritySetupAuditTrailWatchers,
    status_1.coreDataSecurityStatusWatchers,
    monitors_dashboard_1.coreDataSecurityUptimeMonitorsDashboardWatchers,
    usage_1.coreDataSecurityUsageWatchers
]);
//# sourceMappingURL=index.js.map